import { DataTable } from 'simple-datatables';

/**
 * This vanilla version of DataTables is setup to work off of data attributes you add to an element
 * 1. Add the class '.datatable' to your table element
 * 2. Update the following options if your usecase requires a new option. To update
 *    set a new default value in the options object, and then check the element for the
 *    data attribute and turn on that option like `if element.dataset.something...`
 *
 * Usage
 * Docs for library: https://github.com/fiduswriter/Simple-DataTables
 *
 * Make it:
 * - searchable:          data-datatables-search="true"
 * - sortable:            data-datatables-sortable="true"
 * - paginated:           data-datatables-paging="10" where value is per page value
 * - fixed height:        default is true, so turn this off with data-datatables-fixed-height="false"
 * - show next/prev nav:  data-datatables-next-prev="true"
 */
document.addEventListener('turbolinks:load', () => {
  // Initialize datatables
  const dataTableElements = document.querySelectorAll('.datatable');
  window.dataTables = [];

  if (dataTableElements) {
    const dataTableOptions = {
      fixedHeight: false,
      destroy: true,
      searchable: false,
      paging: false,
      sortable: true,
      perPageSelect: false,
      nextPrev: false,
    };

    dataTableElements.forEach((element) => {
      if (element.dataset.datatablesSearch) {
        dataTableOptions.searchable = element.dataset.datatablesSearch === 'true';
      }
      if (element.dataset.datatablesPaging) {
        dataTableOptions.paging = true;
        dataTableOptions.perPage = parseInt(element.dataset.datatablesPaging, 10);
      }
      if (element.dataset.datatablesSortable) {
        dataTableOptions.sortable = element.dataset.datatablesSortable === 'true';
      }
      if (element.dataset.datatablesPerPageSelect) {
        dataTableOptions.perPageSelect = element.dataset.datatablesPerPageSelect === 'true';
      }
      if (element.dataset.datatablesFixedHeight) {
        dataTableOptions.fixedHeight = element.dataset.datatablesFixedHeight === 'true';
      }
      if (element.dataset.datatablesNextPrev) {
        dataTableOptions.nextPrev = element.dataset.datatablesNextPrev === 'true';
      }
      window.dataTables.push(new DataTable(element, dataTableOptions));
    });
  }
});
